import { outgoingPostbackApi } from "api/TenantSlug/OutgoingPostback/api.ts";

export function composeGetOutgoingPostbackQueryOptions(postbackId: string, request?: unknown) {
    return {
        queryKey: ["getOutgoingPostback", postbackId, request],
        queryFn: () => outgoingPostbackApi.show(postbackId, request),
    };
}

export const getOutgoingPostbackQueryOptions = (postbackId: string, request?: unknown) => {
    return {
        ...composeGetOutgoingPostbackQueryOptions(postbackId, request),
        suspense: true,
    };
};
